
export const TermsAndConditions = () => {
  return (
    <div className="space-y-2">
      <h3 className="font-semibold mb-2 text-sm">Terms and Conditions:</h3>
      <ol className="list-decimal list-inside space-y-1 text-xs">
        <li>Payment is due within 60 days from the date of this purchase order.</li>
        <li>This purchase order is non-transferable and binding under Saudi Commercial Law.</li>
        <li>All amounts are in Saudi Riyals (SAR) and subject to applicable VAT regulations.</li>
        <li>This purchase order is valid for the specified campaign only.</li>
        <li>Any disputes will be resolved according to the laws of the Kingdom of Saudi Arabia.</li>
        <li>By accepting this purchase order, both parties agree to comply with Saudi Digital Advertising Regulations.</li>
      </ol>
    </div>
  );
};

